document.querySelector("#slider").addEventListener("input", (e)=>{
  const sliderPos = e.target.value;
  // console.log('sliderPos', sliderPos);
  // Update the width of the foreground image
  // document.querySelector('.foreground-img').css('width', `${sliderPos}%`);
  document.querySelector('.foreground-img').style.width = `${sliderPos}%`;
  // Update the position of the slider button
  // document.querySelector('.slider-button').css('left', `calc(${sliderPos}% - 18px)`);
  document.querySelector('.compare-slider-button').style.left = `calc(${sliderPos}% - 19px)`;

});